<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">同类图书馆</p>
            <router-link  :to="`/index`"  class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>同类图书馆
            </router-link>
            <div class="pub_xian"></div>
        </div>

        <div id="content">
          <div class="tlpro_title">{{info.title}}</div>
          <div class="h-15"></div>
          <div v-html="info.content"></div>
        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue'
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      info:[],
      left:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;

        that.$api.post("/index/tlprocont",{'id':that.id}).then(res => {
          console.log(res);
          that.info= res.info;
          that.loading = false
        });
    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/TlproCont.vue